const navigateToQceTemplate = (navigate, record) =>
  navigate("/manage-qce-templates", {
    state: { manageData: record },
  });

export const qceEmailColumns = (navigate, options = {}) => [
  {
    title: "Template Name",
    key: "templateName",
    dataIndex: "templateName",
  },
  {
    title: "Last Modified",
    dataIndex: "modifiedAt",
    key: "modifiedAt",
  },
  {
    title: "Actions",
    key: "action",
    render: (record) => {
      if (!options.showView && !options.showManage) {
        return null;
      }

      return (
        <div className="action-icons">
          <div>
            {options.showManage && (
              <button
                className="manage"
                onClick={() => navigateToQceTemplate(navigate, record)}
              >
                Manage
              </button>
            )}
            {options.showView && (
              <button
                className="manage"
                onClick={() => navigateToQceTemplate(navigate, record)}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
